/* raw layout hash: _default-web-layout:cc450240bf1982e296dbf23849713c217dc69a0b88962c3626a46347392fc869 */
import DefaultWebShell from './components/DefaultWebShell.jsx';

/**
 * Layout `_default-web-layout`
 * Source shell: RawHTMLDesign/layouts/_default-web-layout.html
 *
 * The project's primary authenticated shell: fixed-top navbar (brand, menuData
 * navigation, session chrome), the `<!-- main content -->` outlet, and the
 * design's empty footer region.
 *
 * Pages using this layout: App Gallery, Model Registry, Workflow Editor,
 * Generation Studio, Review Queue — all authenticated, so the navbar renders the
 * signed-in details + log out (and the log-in affordance if the session is gone).
 *
 * Shell-specific note: this variant declares font-awesome inline in `<head>` and
 * carries both a theme `<style>` and a page `<style>` slot. In this project
 * font-awesome is an npm dependency imported in src/index.jsx and the theme lives
 * in src/scss, so those `<head>` slots have no component-level equivalent.
 */
export default function DefaultWebLayout({ children }) {
  return <DefaultWebShell>{children}</DefaultWebShell>;
}
